import React from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';

import CourseCard from '@ts-core/components/CourseCard/CourseCard';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
  },
}));

const CoursesList = (props) => {
  const { courses, onSelectCourse, loading } = props;
  const classes = useStyles();

  return (
    <Grid container spacing={3} direction="row" className={classes.root}>
      {courses.map((course, index) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
          <CourseCard
            course={course}
            onSelectCourse={onSelectCourse}
            loading={loading}
          />
        </Grid>
      ))}
    </Grid>
  );
};

CoursesList.propTypes = {
  courses: PropTypes.array,
  loading: PropTypes.bool,

  onSelectCourse: PropTypes.func,
};

CoursesList.defaultProps = {
  courses: [],
  loading: false,

  onSelectCourse() {},
};

export default CoursesList;
